export default __webpack_public_path__ + "static/media/noSelection.d3b6e648.svg";